import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import { Element } from 'react-scroll';
import KV from './components/kv';
import TopMenu from '@src/business-components/top-menu';
import Part1 from './components/part1';
import Part2 from './components/part2';
import Part3 from './components/part3';
import Part4 from './components/part4';
import OrderTipsModal from '@src/business-components/order-tips-modal';
import OrderModal from '@src/business-components/order-modal';
import OrderSuccessModal from '@src/business-components/order-success-modal';
import VideoModal from '@src/business-components/video-modal';
import GiftRuleModal from '@src/business-components/gift-rule-modal';
const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <React.Fragment>
      {' '}
      <Page className={styles.root}>
        <TopMenu store={store.topMenuStore} indexWebUrl={store.websiteUrl} onOrderClick={store.openOrderTipsModal} />

        <Element id="kv" data-name="kv">
          <KV store={store.KVStore} onGiftRuleClick={store.openGiftRuleModal} />
        </Element>
        <Element id="activity" data-name="公测活动">
          <Part1 />
        </Element>
        <Element id="feature" data-name="游戏特色">
          <Part2 />
        </Element>
        <Element id="sect" data-name="门派介绍">
          <Part3 onPlayVideo={store.openVideoModal} />
        </Element>
        <Element id="channel" data-name="关注我们">
          <Part4 store={store.part4Store} />
        </Element>
        <OrderTipsModal store={store.orderTipsModalStore} onOrderClick={store.openOrderModal} />
        <OrderModal store={store.orderModalStore} />
        <OrderSuccessModal store={store.orderSuccessModalStore} />
        <VideoModal store={store.videoModalStore} />
        <GiftRuleModal store={store.giftRuleModalStore} />
      </Page>
    </React.Fragment>
  );
};

export default observer(Main);
